module.exports = __webpack_public_path__ + "img/4-s.ad653b50.png";